import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { StatusPill } from "@/components/StatusPill";

export default function FacilityAssignments() {
  const [assignments, setAssignments] = useState([]);
  useEffect(() => { api.get("/assignments").then((r) => setAssignments(r.data)); }, []);

  return (
    <div className="space-y-6" data-testid="facility-assignments">
      <h1 className="text-3xl font-bold text-brand-navy" style={{ fontFamily: "Outfit, sans-serif" }}>Assigned Professionals</h1>
      <div className="grid gap-3">
        {assignments.map((a) => (
          <Card key={a.id} data-testid={`assignment-${a.id}`}>
            <CardContent className="p-5 grid grid-cols-12 gap-3 items-center">
              <div className="col-span-12 md:col-span-4">
                <div className="font-bold text-slate-900">{a.professional?.first_name} {a.professional?.last_name}</div>
                <div className="text-xs text-slate-500">{a.professional?.primary_position} · NetStaff Score {a.professional?.netstaff_score}</div>
              </div>
              <div className="col-span-6 md:col-span-3 text-sm text-slate-600">
                <div>{a.request?.shift_date}</div>
                <div className="text-xs">{a.request?.start_time}-{a.request?.end_time}</div>
              </div>
              <div className="col-span-6 md:col-span-3 text-sm text-slate-600">
                {a.check_in_time && <div>In: {a.check_in_time.slice(11, 16)}</div>}
                {a.check_out_time && <div>Out: {a.check_out_time.slice(11, 16)}</div>}
              </div>
              <div className="col-span-12 md:col-span-2 flex md:justify-end"><StatusPill status={a.status} /></div>
            </CardContent>
          </Card>
        ))}
        {assignments.length === 0 && <div className="text-center py-16 text-slate-500">No assignments yet.</div>}
      </div>
    </div>
  );
}
